import createDependableResource from 'utils/zustand/createDependableResource'
import { multicallv2Encoded } from 'utils/multicall'
import { getAccount, getSigner, onAccountInitOrChange } from 'state/web3/account'
import { getVvsMinerMoleContract } from 'utils/contractHelpers'
import type { Awaited } from 'utils/types'

const fetchMoleTokenIds = async (): Promise<string[]> => {
  const account = getAccount()
  if (!account) return []

  const signer = getSigner()
  const vvsMinerMoleContract = getVvsMinerMoleContract(signer)
  const balanceOfUser = (await vvsMinerMoleContract.balanceOf(account)).toNumber()

  const moleTokenRawIds = (await multicallv2Encoded(
    Array(balanceOfUser)
      .fill(null)
      .map((_, index) => [
        vvsMinerMoleContract,
        'tokenOfOwnerByIndex',
        vvsMinerMoleContract.interface.encodeFunctionData('tokenOfOwnerByIndex', [account, index]),
      ]),
    signer,
  )) as Awaited<ReturnType<typeof vvsMinerMoleContract['tokenOfOwnerByIndex']>>[]

  return moleTokenRawIds.map((tokenId) => tokenId.toString())
}

export const useUserMoleTokenIds = createDependableResource<string[]>({
  initValue: [],
  getValue: fetchMoleTokenIds,
  onInit: ({ resetValue, refresh, getIsStarted }) => {
    onAccountInitOrChange(() => {
      if (!getIsStarted()) return
      resetValue()
      refresh()
    })
  },
  dependResources: [],
  dbgName: 'UserMoleTokenIds',
})
